import { OrderItemStatus } from './order-item-status';

export interface OrderItemComment {
  commentId?: number;
  commentDesc: string;
  createdDateTime: string;
  username: string;
  fullname: string;
  isCustomer: boolean;
  orderRequestItemStatus: OrderItemStatus;
}
